<template>
  <CustomerDetailPlaceholderTab title="Notas de crédito" />
</template>

<script>
import CustomerDetailPlaceholderTab from './CustomerDetailPlaceholderTab.vue';

export default {
  name: 'CustomerDetailCreditNotesTab',
  components: { CustomerDetailPlaceholderTab },
};
</script>
